import { patchAdminChangePermission } from '@api/users/patchAdminChangePermission';
import { updateCustomerUser } from '../../customers/_id/users/actions';
import { UpdateUserReferenceRequest } from '@types';
import { updateUserReferences } from '../_idMap/actions';

import { AMPLITUDE_EVENT, createLogSagaWithFn } from '@sonar-software/sonar-analytics';
import { createPatchAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreUsersAdminPatchSlice = createPatchAsyncSlice({
	additionalRequestSteps: [
		{
			actionHandler: createLogSagaWithFn((action) => {
				const { isLocked, isReadOnly } = action.data;

				if (isReadOnly !== undefined) {
					return {
						data: { isReadOnly },
						id: AMPLITUDE_EVENT.USER_PERMISSIONS_UPDATED
					};
				} else if (isLocked !== undefined) {
					return {
						data: { isLocked },
						id: AMPLITUDE_EVENT.USER_STATUS_UPDATED
					};
				}

				return undefined;
			}),
			type: SagaYieldType.Every
		}
	],
	httpSagaOptions: {
		successCombinationActionCreators: [
			updateCustomerUser,
			(request) => {
				const update: UpdateUserReferenceRequest = {
					userId: request.userId
				};

				if (request.isLocked !== undefined) {
					update.isLocked = request.isLocked;
				}

				if (request.isReadOnly !== undefined) {
					update.isReadOnly = request.isReadOnly;
				}

				return updateUserReferences([ update ]);
			}
		]
	},
	name: 'CoreUsersAdmin',
	receive: false,
	request: true,
	requestHandler: patchAdminChangePermission,
	retainDataOnRequest: false
});
